<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon v-if="parentId" @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-toolbar-side-icon v-else @click.stop="drawer = !drawer" class="white--text"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ parentId ? parentId : 'Category' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()" class="white--text">
        <v-icon>autorenew</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-list two-line fill-height>
        <div v-for="(item, index) in items" :key="index">
          <v-list-tile
            :key="item.userId"
            avatar
            ripple
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-btn icon @click="openDeleteCategoryDialog(item.categoryId)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.name }}
                <v-icon class="ml-3" @click="openEditCategoryDialog(item.categoryId, item.name)">edit</v-icon>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary"></v-list-tile-sub-title>
              <v-list-tile-sub-title></v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon :href="'/categories/' + item.categoryId">
                <v-icon color="primary">chevron_right</v-icon>
              </v-btn>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </div>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              {{ parentId ? 'No subcategory yet' : 'No category yet' }}
            </div>
          </v-flex>
        </template>
      </v-list>
      <v-dialog v-model="dialogAddCategory" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Add {{ parentId ? 'Subcategory' : 'Category' }}
          </v-card-title>
          <v-card-text>
            <v-form ref="formAddCategory" v-model="frmAddCategoryValid" @submit.prevent="">
              <v-text-field
                label="Category"
                v-model="txtCategoryName"
                :rules="[v => !!v || 'Category is required', v => (v && v.length >= 3) || 'Category must be 3 characters or more']"
                @keyup.enter="addCategory(txtCategoryName)"
                required
              ></v-text-field>
              <v-btn
                :disabled="!frmAddCategoryValid"
                @click="addCategory(txtCategoryName)"
              >
                Add
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditCategory" max-width="290">
        <v-card>
          <v-card-title class="headline">
            Edit {{ parentId ? 'Subcategory' : 'Category' }}
          </v-card-title>
          <v-card-text>
            <v-form ref="formEditCategory" v-model="frmEditCategoryValid" @submit.prevent="">
              <v-text-field
                label="Category"
                v-model="txtCategoryNewName"
                :rules="[v => !!v || 'Category is required', v => (v && v.length >= 3) || 'Category must be 3 characters or more']"
                @keyup.enter="editCategory(dialogCategoryId, txtCategoryNewName)"
                required
              ></v-text-field>
              <v-btn
                :disabled="!frmEditCategoryValid"
                @click="editCategory(dialogCategoryId, txtCategoryNewName)"
              >
                Save
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogDeleteCategory" max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>

          <v-card-text>
            Are you sure to delete this category?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              class="grey--text"
              @click="dialogDeleteCategory = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              @click="dialogDeleteCategory = false; deleteCategory(dialogCategoryId);"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          @click="openAddCategoryDialog()"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'

export default {
  props: [
    'parentId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      loading: false,
      dialogDeleteCategory: false,
      dialogEditCategory: false,
      dialogAddCategory: false,
      dialogCategoryId: null,
      frmAddCategoryValid: false,
      txtCategoryName: '',
      frmEditCategoryValid: false,
      txtCategoryNewName: '',
      items: []
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getCategories()
  },

  methods: {
    openAddCategoryDialog: function () {
      this.txtCategoryName = ''
      this.dialogAddCategory = true
    },
    addCategory: function (categoryName) {
      this.dialogAddCategory = false
      this.loading = true
      var paramJson
      if (this.parentId) {
        paramJson = { parentId: this.parentId, name: categoryName }
      } else {
        paramJson = { name: categoryName }
      }
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/category', paramJson, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.refreshList()
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    openEditCategoryDialog: function (categoryId, currentName) {
      this.dialogCategoryId = categoryId
      this.txtCategoryNewName = currentName
      this.dialogEditCategory = true
    },
    editCategory: function (categoryId, categoryNewName) {
      this.dialogEditCategory = false
      this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/category/' + categoryId, {
        name: categoryNewName
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.refreshList()
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    openDeleteCategoryDialog: function (categoryId) {
      this.dialogCategoryId = categoryId
      this.dialogDeleteCategory = true
    },
    deleteCategory: function (categoryId) {
      this.dialogDeleteCategory = false
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/category/' + categoryId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.refreshList()
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getCategories()
        promise.then(function () {
          resolve()
        })
      })
    },
    getCategories: function () {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/categories' + (_this.parentId ? '/' + _this.parentId : ''))
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              _this.items = resp.data.data
            } else {
              console.log('unable to load categories: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
              _this.loading = false
            }
          })
      })
      return promise
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
